import React from "react";
import {
  breakpoints,
  Header,
  Paragraph,
  useColorTokens,
  useMediaQuery
} from "@tvg/design-system";
import { Props } from "./types";
import { RunnerComments, CommentsContainer } from "./styled-components";
import { COMMENTS_QA_LABEL } from "../contants";

const textProps = {
  fontWeight: 400
};

const Comments = ({ raceComment = "", runnerComments = [] }: Props) => {
  const colorTokens = useColorTokens();
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);

  return raceComment || runnerComments.length ? (
    <CommentsContainer>
      {!isMobile && (
        <Header tag="h2" fontSize={14} qaLabel={COMMENTS_QA_LABEL.HEADER}>
          Race Prediction
        </Header>
      )}
      {raceComment.length > 0 ? (
        <article>
          <Paragraph
            {...textProps}
            qaLabel={COMMENTS_QA_LABEL.RACE}
            color={colorTokens.content.subtle}
          >
            {raceComment}
          </Paragraph>
        </article>
      ) : (
        <RunnerComments data-qa-label={COMMENTS_QA_LABEL.RUNNER}>
          {runnerComments.map((item, index) => (
            <Paragraph
              {...textProps}
              qaLabel={`${COMMENTS_QA_LABEL.RUNNER}-${index.toString()}`}
              key={item?.number || 0 + index.toString()}
              color={colorTokens.content.subtle}
            >
              {item?.info || ""}
            </Paragraph>
          ))}
        </RunnerComments>
      )}
    </CommentsContainer>
  ) : null;
};

export default Comments;
